import React from "react";
import PropTypes from "prop-types";

import TypeInfo from "./TypeInfo";

export function ClientTypeInfo({ type }) {
  switch (type?.toUpperCase()) {
    case "TRUST":
      return <TypeInfo name="Trust" icon="certificate" />;
    case "BUSINESS":
      return <TypeInfo name="Business" icon="suitcase" />;
    case "ORGANIZATION":
      return <TypeInfo name="Organization" icon="building" />;
    case "ASSOCIATION":
      return <TypeInfo name="Association" icon="building" />;
    case "UNION":
      return <TypeInfo name="Union" icon="building" />;
    default:
      return <TypeInfo name={type} icon="building" />;
  }
}

ClientTypeInfo.propTypes = {
  type: PropTypes.string,
};

ClientTypeInfo.defaultProps = {
  type: undefined,
};

export default ClientTypeInfo;
